"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EventObserver = /*#__PURE__*/_createClass(function EventObserver() {
  var _this = this;
  _classCallCheck(this, EventObserver);
  _defineProperty(this, "handleEventTrigger", function (event) {
    R.forEach(function (subscriber) {
      if (R.path(['ref', 'current'], subscriber) && !subscriber.ref.current.contains(event.target)) {
        subscriber.callback();
      }
    }, _this.subscribers);
  });
  _defineProperty(this, "subscribe", function (ref, callback) {
    if (ref && callback && R.type(callback) === 'Function') {
      if (R.find(R.propEq('ref', ref))(_this.subscribers)) {
        return false;
      }
      _this.subscribers.push({
        ref: ref,
        callback: callback
      });
      return true;
    }
    return false;
  });
  _defineProperty(this, "unsubscribe", function (ref) {
    R.forEachObjIndexed(function (subscriber, index) {
      if (R.prop('ref', subscriber) === ref) {
        _this.subscribers.splice(index, 1);
        return true;
      }
      return false;
    }, _this.subscribers);
    return false;
  });
  this.subscribers = [];
  document.addEventListener('mousedown', this.handleEventTrigger, 1);
});
var delegateInit = function delegateInit() {
  window.eventObserver = new EventObserver();
};
var _default = exports["default"] = delegateInit;